/* eslint-disable no-param-reassign */
import axios from 'axios';
import { loaderService } from '../services';
import { clearSessionToken, getSessionToken } from '../utils';

let auth = null;
let loggingOut = false;
let sessionCheck = null;
let lastSessionCheckAt = 0;

const SESSION_CHECK_URL = '/v1/vehiculos';
const SESSION_CHECK_MIN_INTERVAL_MS = 30 * 1000;

// En estos endpoints un 403 puede ser falta de permiso de la web y no sesión vencida:
// antes de cerrar la sesión se confirma con SESSION_CHECK_URL.
const ENDPOINTS_WITH_SESSION_CHECK = ['/v1/notificaciones', '/v1/vehiculos/status/'];
const needsSessionCheck = (config) => ENDPOINTS_WITH_SESSION_CHECK
  .some((endpoint) => config?.url?.includes(endpoint));

// Igual que la app y trakku-admin: un 403 con sesión iniciada cierra la sesión.
// Sin token (mapa compartido) no se hace nada: esa pantalla maneja su propio error.
const logoutExpiredSession = () => {
  if (loggingOut || !getSessionToken()) return;
  loggingOut = true;
  auth = null;
  clearSessionToken();
  window.location.replace('/');
};

const useApiService = () => {
  const { REACT_APP_BASE_AUTH_URL, REACT_APP_BASE_VEHICLES_URL } = process.env;

  const authInstance = axios.create({
    baseURL: REACT_APP_BASE_AUTH_URL,
    withCredentials: false,
    timeout: 30000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  });

  const vehíclesInstance = axios.create({
    baseURL: REACT_APP_BASE_VEHICLES_URL,
    withCredentials: false,
    timeout: 30000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      Authorization: auth,
    },
  });

  authInstance.interceptors.response.use(
    async (response) => {
      if (response.data.token) {
        auth = response.data.token;
        // await storageService.setToken(
        //   response.data.token,
        // );
        vehíclesInstance.defaults.headers.common.Authorization = auth;
      }
      return response;
    },
    (error) => {
      loaderService.hide();
      if (error.response.status === 403) {
        // storageService.clear();
      }
      return { ...error.response.data, status: error.response.status };
    },
  );

  // Si la sesión venció, la consulta responde 403 y el interceptor cierra la sesión.
  const verifySession = () => {
    const now = Date.now();
    if (sessionCheck || now - lastSessionCheckAt < SESSION_CHECK_MIN_INTERVAL_MS) return;
    lastSessionCheckAt = now;
    sessionCheck = vehíclesInstance
      .get(SESSION_CHECK_URL)
      .catch(() => {})
      .finally(() => {
        sessionCheck = null;
      });
  };

  vehíclesInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      console.log('errorVehicleI', error);
      if (!error.response) return Promise.reject(error);
      if (error.response.status === 403) {
        loaderService.hide();
        if (needsSessionCheck(error.config)) {
          verifySession();
        } else {
          logoutExpiredSession();
        }
      }
      return error.response.status;
    },
  );

  vehíclesInstance.interceptors.request.use(async (config) => {
    const token = getSessionToken();
    config.headers.Authorization = auth || JSON.parse(token);
    return config;
  }, (error) => {
    loaderService.hide();
    console.log('errorVehicleInter', error);
  });

  return { authInstance, vehíclesInstance, verifySession };
};

export { useApiService };
